/**
 * Merge a batch of saved-from-the-panel line items (labor / equipment) into the
 * report's existing array.
 *
 * - An existing entry whose id matches an incoming id is replaced by the incoming one.
 * - Incoming entries with no id are new and are appended.
 * - Ids in `linesToDelete` are dropped, whether they came from `existing` or `incoming`.
 *
 * Ids are compared as strings: the store holds numeric ids from the API while the
 * panel may hand back the same id as a string.
 *
 * Replaces the old `existing.filter(o => o.id !== data[0]?.id)`, which only
 * de-duplicated the first incoming entry and duplicated the rest on every save.
 */
export function mergeLineItems(
  existing: any[] | null | undefined,
  incoming: any[],
  linesToDelete?: Array<string | number> | null,
): any[] {
  const incomingIds = new Set(
    (incoming || [])
      .map(o => o?.id)
      .filter(id => id !== null && id !== undefined)
      .map(id => String(id)),
  );
  const deleteIds = new Set((linesToDelete || []).map(id => String(id)));

  const kept = (existing || []).filter(o =>
    !incomingIds.has(String(o?.id)) && !deleteIds.has(String(o?.id)),
  );
  const added = (incoming || []).filter(o =>
    o?.id === null || o?.id === undefined || !deleteIds.has(String(o.id)),
  );

  return [...kept, ...added];
}
